import { useEffect, useState } from "react";
import axios from "../../../axios"; // Adjust the path as necessary
import dayjs from "dayjs";

export default function SalesByProductPage() {
    const [data, setData] = useState([]);
    const [range, setRange] = useState({
        start: dayjs().startOf("month").format("YYYY-MM-DD"),
        end: dayjs().endOf("month").format("YYYY-MM-DD"),
    });
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await axios.get("/admin/sales-report/by-product", {
                params: range,
            });
            setData(res.data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const totalSales = data.reduce((acc, d) => acc + d.total_sales, 0);

    const handleInputChange = (e) => {
        setRange({ ...range, [e.target.name]: e.target.value });
    };

    return (
        <div className="card mt-24">
            <div className="card-header border-bottom">
                <h5>Laporan Penjualan per Produk</h5>
            </div>

            <div className="card-body">
                <div className="d-flex align-items-end gap-3 mb-3">
                    <div>
                        <label className="form-label">Dari</label>
                        <input
                            type="date"
                            name="start"
                            value={range.start}
                            className="form-control"
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label className="form-label">Sampai</label>
                        <input
                            type="date"
                            name="end"
                            value={range.end}
                            className="form-control"
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <button onClick={fetchData} className="btn btn-main">Filter</button>
                    </div>
                </div>

                {loading ? (
                    <p>Loading...</p>
                ) : (
                    <>
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Produk</th>
                                    <th>Total Order</th>
                                    <th>Total Penjualan</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((d) => (
                                    <tr key={d.product_id}>
                                        <td>{d.product_name}</td>
                                        <td>{d.total_orders}</td>
                                        <td>Rp{d.total_sales.toLocaleString("id-ID")}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <h5>Total Semua Penjualan: <strong>Rp{totalSales.toLocaleString("id-ID")}</strong></h5>
                    </>
                )}
            </div>
        </div>
    );
}
